import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3598cc0a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "all-director-actor",
  "element-loading-background": "transparent"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "left-warp"
};
const _hoisted_4 = {
  class: "action-title"
};
const _hoisted_5 = {
  class: "total"
};
const _hoisted_6 = {
  key: 0,
  class: "movies-list"
};
const _hoisted_7 = {
  key: 1,
  class: "movies-list"
};
const _hoisted_8 = {
  key: 2,
  class: "pagination"
};
const _hoisted_9 = {
  class: "page-span"
};
import MoviesOrActorItem from './moviesOrActorItem.vue';
import OtherMOAItem from './otherMOAItem.vue';
import { Search } from '@element-plus/icons-vue';
import { inject, onMounted } from 'vue';
import { axiosInstanceAll } from '@/api/instance';
import { vodPlusBaseUrl } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'allDirectorsOrActor',
  props: {
    // modelValue: {
    //   type: Boolean,
    //   default: false
    // },
    showSearchInput: {
      type: Boolean,
      default: true
    }
  },
  emits: ['onCardClick'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const searchParams = reactive({
      loading: false,
      paginationConfig: {
        page: 0,
        limit: 12,
        total: 0
      },
      formData: {
        name: ''
      }
    });
    const screenDialog = reactive({
      visible: false
    });
    const moviesList = ref([]);

    const getData = async () => {
      console.log('get Data');
      moviesList.value = [];
      searchParams.loading = true;

      try {
        // console.log('currentParams.value', currentParams.value);
        const {
          programListUrl
        } = currentParams.value;
        const res = await axiosInstanceAll({
          method: 'get',
          url: '/vodPlus' + programListUrl.replace(vodPlusBaseUrl, ''),
          params: {
            usertoken: sessionStorage.getItem('vodPlusToken'),
            start: searchParams.paginationConfig.page * searchParams.paginationConfig.limit,
            total: searchParams.paginationConfig.limit,
            ...searchParams.formData
          },
          noRepetition: true
        });
        console.log(res);

        if (res.status == 200) {
          moviesList.value = res.data && res.data.castList.map(item => {
            return { ...item,
              type: 'cast'
            };
          }) || [];
          searchParams.paginationConfig.total = res.data.totalNum || 0;
          searchParams.loading = false;
        } else {
          searchParams.loading = false;
        }
      } catch (error) {
        // console.log(error);
        if (error.message !== 'canceled') {
          searchParams.loading = false;
        }
      }
    };

    const onSearch = () => {
      console.log(searchParams.formData.name);
      searchParams.paginationConfig.page = 0;
      getData();
    };

    const handlePaginationChange = val => {
      searchParams.paginationConfig.page = val - 1;
      getData();
    };

    const itemClick = item => {
      emit('onCardClick', item);
    };

    onMounted(() => {
      getData();
    });
    const currentUiStyleOptions = inject('currentUiStyleOptions');
    const currentParams = inject('currentParams');
    watch(() => currentUiStyleOptions.value.styleName, val => {
      if (val) {
        searchParams.paginationConfig.limit = val == 'style2' ? 15 : 12;
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_empty = _resolveComponent("el-empty");

      const _component_el_pagination = _resolveComponent("el-pagination");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(_unref(currentUiStyleOptions).class)
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString('All ' + _unref(currentParams).name), 1), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('Total')) + ": " + _toDisplayString(searchParams.paginationConfig.total), 1)]), __props.showSearchInput ? (_openBlock(), _createBlock(_component_el_input, {
        key: 0,
        modelValue: searchParams.formData.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchParams.formData.name = $event),
        placeholder: _ctx.$t('请输入关键字')
      }, {
        append: _withCtx(() => [_createVNode(_component_el_button, {
          icon: _unref(Search),
          onClick: onSearch
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["modelValue", "placeholder"])) : _createCommentVNode("", true)]), _unref(currentUiStyleOptions).styleName == 'default' || _unref(currentUiStyleOptions).styleName == 'style1' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [moviesList.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(moviesList.value, (item, index) => {
        return _openBlock(), _createBlock(MoviesOrActorItem, {
          onClick: $event => itemClick(item),
          poster: item.image,
          programName: item.name,
          rating: item.rating,
          "program-name-color": "#fff"
        }, null, 8, ["onClick", "poster", "programName", "rating"]);
      }), 256)) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        style: {
          "width": "100%"
        },
        "image-size": 50
      }))])) : _createCommentVNode("", true), _unref(currentUiStyleOptions).styleName == 'style2' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [moviesList.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(moviesList.value, (item, index) => {
        return _openBlock(), _createBlock(OtherMOAItem, {
          onClick: $event => itemClick(item),
          infoItem: item
        }, null, 8, ["onClick", "infoItem"]);
      }), 256)) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        style: {
          "width": "100%"
        },
        "image-size": 50
      }))])) : _createCommentVNode("", true), searchParams.paginationConfig.total > searchParams.paginationConfig.limit ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_pagination, {
        small: "",
        background: "",
        layout: "slot, prev, pager, next",
        "current-page": searchParams.paginationConfig.page + 1,
        "page-size": searchParams.paginationConfig.limit,
        total: searchParams.paginationConfig.total,
        onCurrentChange: handlePaginationChange
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_9, _toDisplayString(searchParams.paginationConfig.page * searchParams.paginationConfig.limit + 1 + '-' + (searchParams.paginationConfig.total / (searchParams.paginationConfig.page + 1) > searchParams.paginationConfig.limit ? (searchParams.paginationConfig.page + 1) * searchParams.paginationConfig.limit : searchParams.paginationConfig.total)) + " of " + _toDisplayString(searchParams.paginationConfig.total) + " items ", 1)]),
        _: 1
      }, 8, ["current-page", "page-size", "total"])])) : _createCommentVNode("", true)], 2)])), [[_directive_loading, searchParams.loading]]);
    };
  }

});